import { configWithUserToken } from "./config";

export interface IMyRestaurant {
  id: string;
  name: string;
  /** Boşsa yanıtta hiç gelmez */
  logoPath?: string;
  /** RestaurantAvailability ile aynı kural: restoran açık VE çalışma saati açık */
  isOpenNow: boolean;
}

/**
 * Çağıranın kendi ETKİN restoran bağları, ada göre (girişteki `restaurants` ile aynı sıra;
 * ilk eleman varsayılan restorandır). Bağ yoksa [] döner. SuperAdmin de yalnız kendi bağlarını görür.
 */
export const getMyRestaurants = () =>
  configWithUserToken.get<IMyRestaurant[]>("RestourantUser/my-restaurants");

/** Kullanıcı ↔ restoran bağı (açık ya da kapalı). */
export interface IUserRestaurantLink {
  id: string;
  customerId: string;
  restourantId: string;
  restourantUserIsEnabled: boolean;
  restourants?: { restaurantId: string; restaurantName?: string | null } | null;
}

/**
 * Bir kullanıcının restoran bağları (birden çok olabilir). SuperAdmin hepsini görür.
 * ⚠️ Hiç bağ yoksa 404 RestourantUserNotFound döner — çağıran boş liste saymalı.
 */
export const getUserRestaurantLinks = (customerId: string) =>
  configWithUserToken.get<IUserRestaurantLink[]>(`RestourantUser/RestourantByUserId/${customerId}`);

/**
 * Kullanıcıyı bir restorana daha bağlar. Aynı çift zaten varsa (kapalı olsa da)
 * 400 RestourantUserAlreadyLinked — kapalı bağ `setRestaurantUserLinkStatus` ile açılır.
 */
export const linkUserToRestaurant = (customerId: string, restourantId: string) =>
  configWithUserToken.post<IUserRestaurantLink>("RestourantUser", {
    customerId, restourantId, restourantUserIsEnabled: true,
  });

/** Bağı açar/kapatır (silme yok). Çok restoranlı kullanıcıda yalnız o restoranın bağı etkilenir. */
export const setRestaurantUserLinkStatus = (restourantUserId: string, isEnabled: boolean) =>
  configWithUserToken.put<IUserRestaurantLink>(
    `RestourantUser/SetRestourantUserStatus/${restourantUserId}?isEnabled=${isEnabled}`
  );
